import { useEffect, useState } from "react";
import { aboutUs } from "../../services/StaticService";

const AboutUs = () => {

  const [aboutusdata, setAboutUsData] = useState({});

  const getAboutUsDetails = async () => {
    const result = await aboutUs();
    if (Object.keys(result).length > 0) {
      setAboutUsData(result);
    }
  }

  useEffect(() => {
    getAboutUsDetails();
  }, []);

  return (
    <section className="about_sec" id="about-us">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-md-5">
            <h6 className="title_txt yellow mb-4 md-sm-5 position-relative">
              About Us
            </h6>
          </div>
          <div className="col-md-6">
          </div>
          <div className="col-md-6 mt-4 mt-md-0">
            <div className="about_content">
              <div dangerouslySetInnerHTML={{__html: aboutusdata?.content}}></div>
              {/* <h6 className="black mb-md-4 mb-3">
                AI-Powered Recipe Assistant
              </h6>
              <p className="gray">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sint,
                odit explicabo. Corporis libero sunt voluptatem perspiciatis
                blanditiis modi atque consequatur ducimus repellendus
                consequuntur consectetur?
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
